import styled from 'styled-components'

interface DivProps {
  width?: string
  backgroundColor?: string
  backgroundImage?: string
  verticalAlign?: string
  extraCss?: string
  color?: string
  buttonWidth?: string
  fontSize?: string
  hasFontSize?: boolean
}

export const Container = styled.div`
  width: ${({ width }: DivProps) => width ? width : '100%'};
  text-align: center;
  height: 100%;
  padding: 14px 28px;
  color: black;
  background: ${({ backgroundColor }: DivProps) => backgroundColor || 'unset'};
  ${({ verticalAlign }: DivProps) => verticalAlign ? `
    display: flex;
    align-items: ${verticalAlign};
  ` : ''}
  ${({ backgroundImage }: DivProps) => backgroundImage ? `
    background-image: url(${backgroundImage});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    @media (max-width: 767px) {
      background-size: cover;
    }
    @media (max-width: 698px) {
      max-width: 100%;
    }
  ` : ''}
  ${({ hasFontSize, extraCss }: DivProps) => extraCss ? `
    display: flex;
    align-items: center;
    ${extraCss}
    ${hasFontSize ? `
      span[data-text="true"] {
        ${extraCss}
      }
    ` : ''}
  ` : ''}
  .rdw-editor-wrapper {
    width: 100%;
  }
  figure:focus-visible {
    outline: none !important;
  }
  @media (max-width: 698px) {
    .public-DraftStyleDefault-ltr {
      direction: inherit !important;
      text-align: inherit !important;
    }
  }
`

export const ImagePreview = styled.img`
  object-fit: cover;
  width: 100%;
  cursor: pointer;
`

export const VideoPreview = styled.video`
  object-fit: contain;
  margin-bottom: -3px;
  width: 100%;
`

export const StyledLink = styled.a`
  transition: all .25s;
  border-radius: 25px;
  padding: 8px 20px;
  box-shadow: 0px 2px 4px -1px #8e8e8e;
  color: ${({ color }: DivProps) => color || 'white'};
  background: ${({ backgroundColor }: DivProps) => backgroundColor || 'black'};
  width: ${({ buttonWidth }: DivProps) => buttonWidth || 'fit-content'};
  font-size: ${({ fontSize }: DivProps) => fontSize || 'auto'};
  &:hover {
    cursor: pointer;
  }
`

export const StyledImageButton = styled.a`
  width: fit-content;
`

export const ImageButton = styled.img`
  width: 100%;
  max-width: ${({ buttonWidth }: DivProps) => buttonWidth || 'fit-content'};
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/CarouselRichItem/styledComponents.tsx